// extracted by mini-css-extract-plugin
export default {"item":"Item_item__FYvUI","item__head":"Item_item__head__wJAM1","item__delivery":"Item_item__delivery__awlm9","item__details":"Item_item__details__ixl8r"};